module.exports = __webpack_public_path__ + "1dc35d25e61d819a9c357074014867ab.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/font-awesome/4.6.3/font-awesome/fonts/fontawesome-webfont.ttf?v=4.6.3
 ** module id = 540
 ** module chunks = 0
 **/